import {QuantityConfiguration} from '../../../../fields/quantity/types'
import {isMultipleTruck} from '../../../../fields/trucks/trucks.utils'
import {TruckConfiguration, TruckForm} from '../../../../fields/trucks/types'
import {CreateFormInput} from '../types'

import {getDefaultTruckSize, getOrderTruckMaxLoad} from './trucks.utils'

export const buildTruckForm = ({
  order,
  configuration: {trucks}
}: CreateFormInput<TruckConfiguration & QuantityConfiguration>): TruckForm => {
  const truckMaxLoad = getOrderTruckMaxLoad(order) || getDefaultTruckSize(trucks)
  return {
    truckType: undefined,
    isMultipleTruck: isMultipleTruck(order.lineItems[0].quantity, truckMaxLoad)
  }
}
